import React, { useEffect } from 'react';
import { Modal, Icon, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSSPARepresentative, fetchSSPARepresentativeFilter, sspaRepresentativeClear, sspaRepresentativeFilterClear } from 'app/actions/SSPARepresentativeActions';
import { getSSPARepresentative, getSSPARepresentativeFilter, getIsLoadingSSPARepresentative } from 'app/reducers';
import IconButton from '@material-ui/core/IconButton';
import ApiService from 'app/services/ApiService';
import { setTimeout } from 'timers';
import isEmpty from 'app/utils/IsEmpty';

export default function SSPARepresentativeTableContainer(props) {
    const { classes } = props;
    const { confirm } = Modal;

    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;


    const {
        siteId
    } = useSelector(state => state.Auth);

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'responsibleName',
            key: 'responsibleName',
            sorter: true,
            width: '100%',
            ellipsis: true

        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'idResponsible',
            fixed: 'right',
            // width: '100%',
            render: (text, record) => (
                <div className={classes.buttons}>
                    {siteId === 'HUB' ?
                        <Tooltip placement="bottom" title={'Eliminar'}>
                            <IconButton className={classes.deleteIcon} onClick={() => showConfirmDelete(record)}>
                                <Icon type="delete" />
                            </IconButton>
                        </Tooltip>
                        : null
                    }

                    <Tooltip placement="bottom" title={siteId === 'HUB' ? 'Editar' : 'Visualizar'}>
                        <IconButton className={classes.editIcon} onClick={() => showEdit(record)}>
                            <Icon type={siteId === 'HUB' ? 'edit' : 'eye'} />
                        </IconButton>
                    </Tooltip>

                </div>
            )
        }
    ];

    const showEdit = (param) => {
        props.isVisibleForm(true);
        props.setIdResponsible(param.idResponsible);
        props.setNameResponsible(param.responsibleName);
    }

    const showConfirmDelete = (param) => {
        confirm({
            title: '¿Eliminar Responsable SSPA?',
            content: param.responsibleName,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                props.setFiltroNombre(props.FiltroNombre.filter(x => x !== param.responsibleName));
                return deleteResponsible(param);
            },
            onCancel() { },
        });

    }

    async function deleteResponsible(param) {
        await ApiService.deleteResponsible(param.idResponsible).then(res => {
            dispatch(sspaRepresentativeClear());
            dispatch(sspaRepresentativeFilterClear());
            dispatch(fetchSSPARepresentativeFilter({ idRol: 3 }))
            dispatch(fetchSSPARepresentative({
                responsibleName: props.FiltroNombre.filter(x => x !== param.responsibleName).join(','),
                idRol: 3,
                sortColumn: column,
                sortDir: order, offset: offset, limit: limit
            }));
            const modal = Modal.success({
                title: `Eliminado Correctamente`,
                content: '',
            });

            setTimeout(function () {
                modal.destroy();
            }, 3000)

        });
    }

    let sspaRepresentative = useSelector(getSSPARepresentative);
    let sspaRepresentativeFilter = useSelector(getSSPARepresentativeFilter);

    let isLoading = useSelector(getIsLoadingSSPARepresentative);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(sspaRepresentative)) fetchSSPARepresentativeAction();
        if (isEmpty(sspaRepresentativeFilter)) fetchSSPARepresentativeFilterAction();
    }, []);

    const handleTableChange = (pagination, filters, sorter) => {

        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }

        dispatch(fetchSSPARepresentative(
            {
                responsibleName: props.FiltroNombre.join('|'),
                idRol: 3,
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize
            }));
    };

    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && sspaRepresentative.length > 0) {
            pagination.total = sspaRepresentative[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter != null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }



    const fetchSSPARepresentativeAction = () => dispatch(fetchSSPARepresentative({
        responsibleName: props.FiltroNombre !== undefined ? props.FiltroNombre.join(',') : '',
        idRol: 3,
        sortColumn: column,
        sortDir: order, offset: offset, limit: limit
    }));
    const fetchSSPARepresentativeFilterAction = () => dispatch(fetchSSPARepresentativeFilter({ idRol: 3 }))
    return (props.children({ pagination: pagination, cols: columns, sspaRepresentative, sspaRepresentativeFilter, isLoading, handleTableChange: handleTableChange }));
}

